import { createContext, useContext, useState } from "react";
import axios from "axios";
import localforage from "localforage";

const PcrContext = createContext();

const CACHE_KEY = "ociCache";
const CACHE_DURATION = 5 * 60 * 1000; // 5 min

export const PcrProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const BASE_URL = "http://localhost:8000";

  const [pcrStore, setPcrStore] = useState({});
  const [error, setError] = useState("");
  // structure: { RELIANCE: [...data], TCS:[...], etc }

  // ----------------- Fetch Fresh Data -----------------
  const fetchFreshData = async (symbol) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/stockOci`, {
        params: { symbol },
      });

      // extract only useful array
      const extracted = response.data || [];

      // update global store
      setPcrStore((prev) => ({ ...prev, [symbol]: extracted }));

      // update cache
      const cache = (await localforage.getItem(CACHE_KEY)) || {};
      cache[symbol] = { value: extracted, timestamp: Date.now() };
      await localforage.setItem(CACHE_KEY, cache);

      return extracted;
    } catch (error) {
      console.error("❌ Fetch Error:", error);
      setError(error?.response?.data?.message);
    }
  };
  const loadIndexData = async (symbol) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/indicesOci`, {
        params: { symbol },
      });

      const extracted = response.data;

      setPcrStore((prev) => ({ ...prev, [symbol]: extracted }));

      const cache = (await localforage.getItem(CACHE_KEY)) || {};
      cache[symbol] = { value: extracted, timestamp: Date.now() };
      await localforage.setItem(CACHE_KEY, cache);

      return extracted;
    } catch (error) {
      console.error("❌ Error fetching index data:", error);
      setError(error?.response?.data?.message);
    }
  };

  // ----------------- Load Cached or Fetch -----------------
  const loadData = async (symbol) => {
    const cache = await localforage.getItem(CACHE_KEY);

    if (cache && cache[symbol]) {
      const { value, timestamp } = cache[symbol];

      // valid cache
      if (Date.now() - timestamp < CACHE_DURATION) {
        setPcrStore((prev) => ({ ...prev, [symbol]: value }));
        return value;
      }
    }

    // expired cache → fetch fresh
    return fetchFreshData(symbol);
  };

  // manual refresh button support
  const refresh = async (symbol) => fetchFreshData(symbol);

  return (
    <PcrContext.Provider
      value={{ pcrStore, loadData, refresh, loadIndexData, error }}
    >
      {children}
    </PcrContext.Provider>
  );
};

export const usePcr = () => useContext(PcrContext);
